import { CategoryListComponent } from './../category-list/category-list.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoryService } from '../../services/category.service';
import { CategoryDTO } from './category.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Department } from '../user/department.model';
import { UserService } from '../../services/user.service';
import { RoleEnum } from '../../enums/role.enum';


@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrl: './category.component.css',
  standalone: false
})
export class CategoryComponent implements OnInit {
@ViewChild(CategoryListComponent) categoryListCompo:any;
displayedColumns: string[] = [
  'categoryName',
  'categoryType',
  'department'
];
categoryData: CategoryDTO[] = [];
isSubmitting:boolean = false;
submitSuccess: boolean = false;
submitError: string = '';
departments: Department[] = [];
categoryFormGroup: FormGroup;
typeList: any;
userData: any;
isAdmin: boolean=false;
isDepartmentAdmin: boolean = false;

  constructor(
    private categoryService: CategoryService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private userService: UserService
  ){
    this.categoryFormGroup = this.fb.group({
      name: ['', Validators.required],
      categoryTypeId: ['', Validators.required],
      departmentId: ['', Validators.required]
  });}

  ngOnInit(): void {
    this.getCategoryType();
    this.getStorageData();
    this.getDepartments();
    this.setDeptValueForDeptAdmin();
  }

  getStorageData(){
    let user:any = sessionStorage.getItem("userData");
    this.userData = JSON.parse(user);
    this.isAdmin = this.userData.roleId == RoleEnum.ADMIN;
    this.isDepartmentAdmin = this.userData.roleId == RoleEnum.DEPARTMENT_ADMIN;
  }

  getCategoryType(){
    this.categoryService.getCategoryType().subscribe(
      (res: any) => {
        if (res && res.responseObject) {
          if (Array.isArray(res.responseObject)) {
            this.typeList = res.responseObject.map((type: any) => ({
             ...type,
            }));
          }
        } else {
          this.snackBar.open(res.message, 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        }
      },
      (error: any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }
  onSaveCategory(){
    if (this.categoryFormGroup.valid) {
      // const formValue = this.categoryFormGroup.value;
      const formValue = this.categoryFormGroup.getRawValue();
      const categoryData = {
       ...formValue
      };
  
      this.categoryService.create(categoryData).subscribe(
        (res: any) => {
          this.isSubmitting = false;
          this.submitSuccess = true;
          this.categoryData.push(res.responseObject); // Add new user data to the array
          this.categoryListCompo.getAllCategoryForFilter(); // Refresh the table
          this.snackBar.open(res.message, 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
  
          // Reset form and clear error states
          this.categoryFormGroup.reset();
          Object.keys(this.categoryFormGroup.controls).forEach(key => {
            this.categoryFormGroup.get(key)?.setErrors(null);
          });
  
          // Mark form as pristine and untouched
          this.categoryFormGroup.markAsPristine();
          this.categoryFormGroup.markAsUntouched();

          this.setDeptValueForDeptAdmin();
        },
        (error: any) => {
          this.isSubmitting = false;
          this.submitSuccess = false;
          this.submitError = 'Error submitting form';
          this.snackBar.open(error.message, 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center'
          });
        }
      );
    } else {
      this.submitSuccess = false;
      this.submitError = 'Form is invalid. Please check all fields.';
      this.snackBar.open('Form is invalid. Please check all fields.', 'Close', {
        duration: 3000,
        verticalPosition: 'bottom',
        horizontalPosition: 'center'
      });
  
      // Mark all fields as touched to show errors
      this.categoryFormGroup.markAllAsTouched();
    }
  };

  getDepartments(): void {
    this.userService.getDepartments().subscribe(
      (responseObject: Department[]) => {
        this.departments = responseObject.map((department: Department) => ({ id: department.id, departmentName: department.departmentName }));
      },
      (error: any) => {
        this.snackBar.open(error.message, 'Close', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }
    );
  }

  setDeptValueForDeptAdmin(): void {
    if(this.isDepartmentAdmin) {
      this.categoryFormGroup.patchValue({departmentId: this.userData.departmentId});
      this.categoryFormGroup.get('departmentId')?.disable();
    }
  }

}
